export default __webpack_public_path__ + "static/media/ERx_Icon.b24b671c.png";